<template>
  <v-card>
    <ValidateAll ref="form">
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" md="6">
              <div class="headline">{{title()}}</div>
              <br />
              <!-- form goes here -->
              <v-skeleton-loader
                :loading="loading"
                class="actions__left"
                type="list-item-two-line,list-item-two-line"
              >
                <Validate name="NIP" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="NIP"
                    label="NIP"
                    :error-messages="errors"
                    placeholder="NIP"
                    v-model="form.NIP"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Nama Pejabat" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Nama"
                    label="Nama"
                    :error-messages="errors"
                    placeholder="Nama Pejabat"
                    v-model="form.Nama"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>

                <!-- <Validate name="Kode Jabatan" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Kode Jabatan"
                    label="Kode Jabatan"
                    :error-messages="errors"
                    placeholder="Kode Jabatan"
                    v-model="form.KodeJabatan"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>-->
                <Validate name="Jabatan" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Jabatan"
                    label="Jabatan"
                    :error-messages="errors"
                    placeholder="Jabatan"
                    v-model="form.Jabatan"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <v-text-field
                  class="mb-3"
                  name="Pangkat"
                  label="Pangkat"
                  placeholder="Pangkat"
                  v-model="form.Pangkat"
                  hide-details="auto"
                  outlined
                  required
                  dense
                ></v-text-field>
              </v-skeleton-loader>
            </v-col>
            <v-divider vertical class="hidden-xs-only" />
            <v-col cols="12" md="6" class="mr-n1 mt-n12 mt-sm-0 mt-md-0 mt-lg-0 mt-xl-0">
              <div class="headline v-hidden hidden-sm-and-down">{{title()}}</div>
              <br />
              <v-skeleton-loader
                :loading="loading"
                class="actions__left"
                type="list-item-two-line,list-item-two-line, actions"
              >
                <Validate name="Jenis Pejabat" rules="required" #default="{ errors }">
                  <v-select
                    class="mb-3"
                    :items="list.jenisPejabat.data"
                    name="Jenis"
                    label="Jenis"
                    :error-messages="errors"
                    placeholder="Jenis Pejabat"
                    v-model="form.Jenis"
                    :return-object="false"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-select>
                </Validate>
                <Validate
                  v-if="visible.sekolah"
                  name="Nama Sekolah"
                  rules="required"
                  #default="{ errors }"
                >
                  <v-autocomplete
                    class="mb-3"
                    :items="list.sekolah.data"
                    item-text="Nama"
                    item-value="IDSekolah"
                    name="Sekolah"
                    label="Sekolah"
                    :error-messages="errors"
                    placeholder="Nama Sekolah"
                    v-model="form.IDSekolah"
                    :return-object="false"
                    hide-details="auto"
                    outlined
                    dense
                  >
                    <!-- selected slot -->
                    <template v-slot:selection="data">
                      <v-list-item-title>
                        {{data.item.Nama}}
                        &mdash;
                        <span
                          class="text--secondary"
                        >{{data.item.Kode}}</span>
                      </v-list-item-title>
                    </template>
                    <!-- list item slot -->
                    <template v-slot:item="data">
                      <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content v-text="data.item"></v-list-item-content>
                      </template>
                      <template v-else>
                        <v-list-item-content>
                          <v-list-item-title class="py-0">
                            {{data.item.Nama}}
                            &mdash;
                            <span
                              class="text--secondary"
                            >{{data.item.Kode}}</span>
                          </v-list-item-title>
                          <v-list-item-subtitle>{{ data.item.Alamat}} {{ data.item.Lokasi}} {{data.item.Provinsi}}</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </Validate>
                <v-btn class="mr-2" @click="reset">Ulang</v-btn>
                <v-btn color="primary" @click="save()" :loading="saving">
                  <v-icon>mdi-content-save</v-icon>Simpan
                </v-btn>
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </ValidateAll>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    saving: false,
    loading: false,
    form: {
      NIP: "",
      Nama: "",
      Jenis: "",
      IDSekolah: "",
      // KodeJabatan: "",
      Jabatan: "",
      Pangkat: ""
    },
    visible: {
      sekolah: false
    }
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", ["isSekolahLoading"])
  },
  methods: {
    async save() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menyimpan data?"
      });
      if (!confirmation) return;

      this.saving = true;
      this.$axios
        .post("/administration/pejabat", this.form)
        .then(res => {
          this.$dialog.notify.success(res.data.Message, {
            ...this.app.notification
          });
          this.$router.push("/pejabat");
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    reset() {
      // Object.assign(this.$data, this.$options.data());
      this.$refs.form.reset();
    },
    title() {
      return this.$route.params.id ? "Ubah Pejabat" : "Pejabat Baru";
    },

    ...mapActions("list", ["refreshSekolah"])
  },
  async mounted() {
    this.refreshSekolah();
    let id = this.$route.params.id;
    if (id) {
      this.loading = true;
      this.$axios
        .get(`/administration/pejabat/${id}`)
        .then(res => {
          this.loading = false;
          this.form = { ...this.form, ...res.data.Data };
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        });
    }
  },
  watch: {
    "form.Jenis"(newVal) {
      if (newVal == "sekolah") {
        this.visible.sekolah = true;
      } else {
        this.visible.sekolah = false;
        this.form.IDSekolah = "";
      }
    }
  }
};
</script>

<style>
</style>